import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const inviteToken = sessionStorage.getItem("apexgrey_invite_token") || null;
        await api.post("/auth/session", { session_id: sessionId, invite_token: inviteToken });
        sessionStorage.removeItem("apexgrey_invite_token");
        // Clear the fragment
        window.history.replaceState(null, "", "/dashboard");
        await refresh();
        navigate("/dashboard", { replace: true });
      } catch (e) {
        sessionStorage.removeItem("apexgrey_invite_token");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-screen grid place-items-center bg-graphite-950 text-ink-primary" data-testid="auth-callback">
      <div className="text-center">
        <div className="mx-auto h-8 w-8 rounded-full border border-white/20 border-t-white animate-spin" />
        <p className="mt-4 text-sm text-ink-secondary">Signing you in…</p>
      </div>
    </div>
  );
}
